import { render, staticRenderFns } from "./VR1.vue?vue&type=template&id=6fddfac4&scoped=true"
import script from "./VR1.vue?vue&type=script&lang=js"
export * from "./VR1.vue?vue&type=script&lang=js"
import style0 from "./VR1.vue?vue&type=style&index=0&id=6fddfac4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fddfac4",
  null
  
)

export default component.exports